import { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { api } from '../api/client';

export default function ProtectedRoute() {
  const location = useLocation();
  const [onboardingCompleted, setOnboardingCompleted] = useState<boolean | null>(null);
  const token = localStorage.getItem('token');

  useEffect(() => {
    const checkOnboarding = async () => {
      const storedUser = localStorage.getItem('user');
      if (storedUser) {
        try {
          const user = JSON.parse(storedUser);
          setOnboardingCompleted(user.onboarding_completed ?? true);
          return;
        } catch {
          // fall through to API call
        }
      }

      try {
        const response = await api.get('/api/v1/auth/me');
        const user = response.data.user;
        localStorage.setItem('user', JSON.stringify(user));
        setOnboardingCompleted(user.onboarding_completed ?? true);
      } catch {
        setOnboardingCompleted(true);
      }
    };

    if (token) {
      checkOnboarding();
    }
  }, [token]);

  if (!token) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (onboardingCompleted === null) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-gray-600">Loading...</div>
      </div>
    );
  }

  if (!onboardingCompleted && location.pathname !== '/onboarding') {
    return <Navigate to="/onboarding" replace />;
  }

  return <Outlet />;
}
